export default __webpack_public_path__ + "static/media/zukunf_lauft_logo.04fe924b.svg";